export default "__VITE_ASSET__CeeMhsiI__"